import { useEffect, useState } from "react";
import { Search, ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { fmtDateTime } from "@/lib/api";

export function LogTable({ fetcher, showTenant, testId = "logs-table" }) {
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ items: [], pages: 1, total: 0 });
  useEffect(() => {
    const h = setTimeout(() => fetcher({ q, page }).then((r) => setData(r.data)).catch(() => {}), 250);
    return () => clearTimeout(h);
  }, [q, page, fetcher]);
  return (
    <div className="space-y-3">
      <div className="relative max-w-md">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input value={q} onChange={(e) => { setQ(e.target.value); setPage(1); }} placeholder="Buscar por ação ou pessoa" className="pl-9" data-testid={`${testId}-search`} />
      </div>
      <div className="card-surface overflow-x-auto">
        <Table data-testid={testId}>
          <TableHeader><TableRow><TableHead>Data</TableHead>{showTenant && <TableHead>Cliente</TableHead>}<TableHead>Ação</TableHead><TableHead>Quem</TableHead><TableHead>Detalhes</TableHead><TableHead>IP</TableHead></TableRow></TableHeader>
          <TableBody>
            {data.items.map((l) => (
              <TableRow key={l.id}>
                <TableCell className="whitespace-nowrap text-xs">{fmtDateTime(l.created_at)}</TableCell>
                {showTenant && <TableCell className="text-xs">{l.tenant_name}</TableCell>}
                <TableCell className="font-medium">{l.action}</TableCell>
                <TableCell>{l.actor_name}</TableCell>
                <TableCell className="text-xs text-muted-foreground max-w-xs truncate">{l.details || l.path}</TableCell>
                <TableCell className="font-mono text-xs">{l.ip}</TableCell>
              </TableRow>
            ))}
            {!data.items.length && <TableRow><TableCell colSpan={6} className="py-8 text-center text-muted-foreground">Nenhum registro.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
      <div className="flex items-center justify-between text-sm">
        <span className="text-muted-foreground">{data.total} registro(s)</span>
        <div className="flex items-center gap-2">
          <Button size="icon" variant="outline" disabled={page <= 1} onClick={() => setPage(page - 1)}><ChevronLeft className="h-4 w-4" /></Button>
          <span>{page} / {data.pages}</span>
          <Button size="icon" variant="outline" disabled={page >= data.pages} onClick={() => setPage(page + 1)}><ChevronRight className="h-4 w-4" /></Button>
        </div>
      </div>
    </div>
  );
}
